module.exports = __webpack_public_path__ + "static/media/mel-polytech.e4074cc9.jpg";